import * as classnames from 'classnames';
import * as React from 'react';

import { default as MaskedInput } from 'react-text-mask';

import { FormattedMessage } from 'react-intl';
import { change, WrappedFieldProps } from 'redux-form';

import './InputText.scss';

export interface InputTextProps {
  className?: string;
  disabled?: boolean;
  footnote?: string;
  label: string;
  mask?: (value: string) => Array<string | RegExp>;
  modifier?: 'cancel' | 'visibility';
  type: 'email' | 'number' | 'password' | 'tel' | 'text';
}

interface InputTextState {
  isVisibilityActive: boolean;
}

export class InputText extends React.Component<InputTextProps & WrappedFieldProps, InputTextState> {
  private input: HTMLInputElement;

  constructor(props: InputTextProps & WrappedFieldProps) {
    super(props);

    this.state = {
      isVisibilityActive: false
    };
    this.resetInputValue = this.resetInputValue.bind(this);
    this.setReference = this.setReference.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  focus() {
    return this.input.focus();
  }

  render() {
    const { className, footnote, label, meta, type } = this.props;
    const classNameFootnoteError = meta.touched && meta.error && 'input-text__footnote--is-error';
    const classNameType = type && 'input-text__container--' + type;
    return (
      <div className={classnames('input-text__container', classNameType, className)}>
        {this.inputElement}

        <label className="input-text__label" htmlFor={this.inputId}>{label}</label>

        <p className="input-text__footnote">
          {meta.touched && meta.error && <span className={classnames(classNameFootnoteError)}><FormattedMessage id={meta.error}/></span>}
          {!classNameFootnoteError && footnote && <span>{footnote}</span>}
        </p>

        {this.inputAction}
      </div>
    );
  }

  get inputAction() {
    const { modifier, type } = this.props;
    if (modifier === 'cancel') {
      return (
        <i
          className="input-text__action input-text__cancel ic-cancel o-icon-action"
          onTouchStart={this.resetInputValue}
          onMouseDown={this.resetInputValue}
        />
      );
    } else if (type === 'password' && modifier === 'visibility') {
      const classNameActive = this.state.isVisibilityActive && 'input-text__visibility--is-active';
      return (
        <i
          className={classnames('input-text__action input-text__visibility ic-visibility o-icon-action', classNameActive)}
          onClick={this.toggleVisibility}
        />
      );
    }
    return null;
  }

  get inputElement() {
    const { disabled, input, mask, meta, type } = this.props;
    const classNameElementError = meta.touched && meta.error && 'input-text__element--is-error';
    const classNameElementStatus = input.value && 'input-text__element--is-filled';
    if (mask) {
      return (
        <MaskedInput
          autoComplete="off"
          className={classnames('input-text__element', classNameElementError, classNameElementStatus)}
          disabled={disabled}
          guide={false}
          id={this.inputId}
          mask={mask}
          ref={this.setReference}
          spellCheck={false}
          type={type}
          {...input}
        />
      );
    }

    return (
      <input
        autoComplete="off"
        className={classnames('input-text__element', classNameElementError, classNameElementStatus)}
        disabled={disabled}
        id={this.inputId}
        ref={this.setReference}
        spellCheck={false}
        type={type}
        {...input}
      />
    );
  }

  get inputId() {
    return 'input-text__id-' + this.props.input.name;
  }

  private toggleVisibility() {
    if (this.input && this.input.type === 'text') {
      this.input.type = 'password';
      this.setState({ isVisibilityActive: false });
    } else if (this.input && this.input.type === 'password') {
      this.input.type = 'text';
      this.setState({ isVisibilityActive: true });
    }
  }

  private resetInputValue() {
    const { input, meta } = this.props;
    meta.dispatch(change(meta.form, input.name, ''));
  }

  private setReference(htmlInputElement: any) { // TODO
    this.input = htmlInputElement && htmlInputElement.inputElement
      ? htmlInputElement.inputElement : htmlInputElement;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Input/InputText/InputText.tsx